<div class="container" style="padding-left: 60px;padding-right: 60px;">
  <div class="row">
    <div class="col-md-6 here" style="text-align: center" data-aos="fade-right">
      <img src="./assets/images/1.svg" alt="" width="200px" height="200px" >
      <h5 style="text-align: center;font-family: Tangerine,serif;font-size: 40px;">
        Application web</h5>
      <p>Lorem Lorem Lorem LoremLorem LoremLorem LoremLorem LoremLorem LoremLorem Lorem
        Lorem LoremLorem LoremLorem </p>
      <ul>
        <li>Lorem Lorem</li>
      <li>Lorem Lorem</li>
      <li>Lorem Lorem</li>
      </ul>
    </div>
    <div class="col-md-6 " data-aos="fade-left" style="text-align: center">
      <img src="./assets/images/2.svg" alt="" width="200px" height="200px">
      <h5 style="text-align: center;font-family: Tangerine,serif;font-size: 40px;">
        Web-Sites</h5>
      <p>Lorem Lorem Lorem LoremLorem LoremLorem LoremLorem LoremLorem LoremLorem Lorem
        Lorem LoremLorem LoremLorem LoremLorem </p>
    </div>
    <div class="col-md-6 " style="text-align: center" data-aos="fade-right">
      <img src="./assets/images/3.svg" alt="" width="200px" height="200px" >
      <h5 style="text-align: center;font-family: Tangerine,serif;font-size: 40px;">
        Application web</h5>
      <p>Lorem Lorem Lorem LoremLorem LoremLorem LoremLorem LoremLorem LoremLorem Lorem
        Lorem LoremLorem LoremLorem </p>
      <ul>
        <li>Lorem Lorem</li>
        <li>Lorem Lorem</li>
        <li>Lorem Lorem</li>
      </ul>
    </div>
    <div class="col-md-6 here" style="text-align: center" data-aos="fade-left">
      <img src="./assets/images/4.svg" alt="" width="200px" height="200px">
      <h5 style="text-align: center;font-family: Tangerine,serif;font-size: 40px;">
        Web-Sites</h5>
      <p>Lorem Lorem Lorem LoremLorem LoremLorem LoremLorem LoremLorem LoremLorem Lorem
        Lorem LoremLorem LoremLorem LoremLorem </p>
    </div>
    <div class="col-md-3"></div>
    <div class="col-md-6 " style="text-align: center"  data-aos="zoom-in">
      <img src="./assets/images/5.svg" alt="" width="200px" height="200px" >
      <h5 style="text-align: center;font-family: Tangerine,serif;font-size: 40px;">
        Application web</h5>
      <p>Lorem Lorem Lorem LoremLorem LoremLorem LoremLorem LoremLorem LoremLorem Lorem
        Lorem LoremLorem LoremLorem </p>
      <ul>
        <li>Lorem Lorem</li>
        <li>Lorem Lorem</li>
        <li>Lorem Lorem</li>
      </ul>
    </div>
    <div class="col-md-3"></div>
  </div>

</div>
